module.exports = __webpack_public_path__ + "img/informal-leader-manipulator.2f33553c.svg";